<template>
	<div id="map" :style="styleProp"></div>
</template>

<script>
export default {
	props: ['styleProp', 'mapcenter', 'zoom', 'prefillAddress', 'radius'],
	data() {
		return {
			map: null,
			circle: null,
			geocoder: null
		}
	},
	mounted() {
		this.map = new google.maps.Map(document.getElementById('map'), {
			center: this.mapcenter,
			zoom: this.zoom,
			disableDefaultUI: true,
			zoomControl: true
		})

		this.createCircle()
	},
	watch: {
		mapcenter() {
			this.map.setCenter(this.mapcenter)
			if (this.circle) {
				this.circle.setCenter(this.mapcenter)
			}
		},
		radius() {
			if (this.circle) {
				this.circle.setRadius(this.radius)
			}
		},
		zoom() {
			this.map.setZoom(this.zoom)
		}
	},
	methods: {
		createCircle() {
			this.circle = new google.maps.Circle({
				strokeColor: '#FF0000',
				strokeOpacity: 0.8,
				strokeWeight: 2,
				fillColor: '#FF0000',
				fillOpacity: 0.35,
				map: this.map,
				center: this.mapcenter,
				radius: this.radius
			})
		}
	},
	computed: {}
}
</script>
